import Image from 'next/image';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface Props {
  smallImages?: { url: string }[];
  smallImageClassName?: string;
  setCurrentImage?: (index: number) => void;
  showSmallImages?: boolean;
}

const SmallImages = ({ showSmallImages, smallImages, smallImageClassName, setCurrentImage }: Props) => {
  const { t } = useTranslation();
  return showSmallImages ? (
    <div className={`w-full mt-3 2xl:h-24 lg:h-14 md:h-8 sm:h-4 flex flex-row justify-start ${smallImageClassName}`}>
      {smallImages.map((image, index) => (
        <div key={image.url} className={`w-1/5 me-2 relative 2xl:h-24 lg:h-14 md:h-8 sm:h-4 ${smallImageClassName}`}>
          <Image
            onClick={() => setCurrentImage(index)}
            style={{ objectFit: 'cover' }}
            unoptimized
            alt={t('common.carouselImageAlt')}
            className="rounded-2xl md:rounded-md me-2"
            fill
            src={image.url}
            loading="lazy"
          />
        </div>
      ))}
    </div>
  ) : null;
};

export default SmallImages;
